<script setup lang="ts">
interface Props {
  slot: any;
}

withDefaults(defineProps<Props>(), {});

const emit = defineEmits(['slot-clicked']);

const BASE_CLASSES =
  'w-[80px] h-[80px] rounded-full flex items-center justify-center';
</script>
<template>
  <div data-pressable @click="emit('slot-clicked', slot)">
    <div
      v-if="slot.state === 'AVAILABLE'"
      :class="BASE_CLASSES"
      class="shadow-smallBottom bg-neutral-0"
    >
      <div
        class="w-8 h-8 bg-green-400 rounded-full flex items-center justify-center"
      >
        <fa-icon class="text-xl text-neutral-0" :icon="['fas', 'plus']" />
      </div>
    </div>

    <div
      v-if="slot.state === 'BOOKED'"
      :class="BASE_CLASSES"
      class="shadow-smallBottom"
    >
      <img
        class="w-full h-full bg-cover rounded-full border-4 border-neutral-0"
        v-optimized="{ src: slot.participants[0].displayImage }"
      />
    </div>

    <div
      v-if="slot.state === 'EXPIRED'"
      :class="BASE_CLASSES"
      class="bg-neutral-0 opacity-50"
    >
      <img
        v-if="slot.participants.length"
        class="w-full h-full bg-cover rounded-full border-4 border-neutral-0"
        v-optimized="{ src: slot.participants[0].displayImage }"
      />
    </div>

    <div
      v-if="slot.state === 'LOCKED'"
      :class="BASE_CLASSES"
      class="border border-2 border-neutral-300"
    >
      <fa-icon class="text-3xl" :icon="['fas', 'lock']" />
    </div>
  </div>
</template>
